import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { SubdomainService } from "src/app/core/_base/subdomain.service";
import { environment } from "src/environments/environment";
import { WorkScope, WorkScopeOption } from "./types";
import { v4 as uuidv4 } from 'uuid'

@Injectable({
  providedIn: 'root'
})
export class NatureAndExtentOfValuersWorkService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subDomainService: SubdomainService
  ) {}

  fetchList(agencyId: number) {
    return this.http.get<{data: WorkScopeAPIResource[]}>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/agencies/${agencyId}/scope-of-works`,
      {
        headers: this.authService.getAuthHeaders()
      }
    ).pipe(
      map(response => mapApiResourceToModel(response.data))
    )
  }
}

interface WorkScopeAPIResource {
  id?: number
  name: string
  is_system: boolean,
  selected_option_id?: number,
  selected_option_index?: number,
  report_type_id: number
  options: WorkScopeOptionAPIResource[],
}

interface WorkScopeOptionAPIResource {
  id?: number
  is_system: boolean,
  default_name: string
  default_description: string
  name: string,
  description: string
}

function mapApiResourceToModel(items: WorkScopeAPIResource[]): WorkScope[] {
  return items.map(item => {
    const options = mapOptions(item.options)
    return {
      id: item.id ? item.id : uuidv4(),
      isSystem: item.is_system,
      name: item.name,
      options,
      selectedOptionId: getSelectedOptionId(item, options),
      reportTypeId: item.report_type_id
    }
  })
}

function mapOptions(items: WorkScopeOptionAPIResource[]): WorkScopeOption[] {
  return items.map(item => {
    return {
      id: item.id ? item.id : uuidv4(),
      isSystem: item.is_system,
      defaultName: item.default_name,
      defaultDescription: item.default_description,
      name: item.name,
      description: item.description
    }
  })
}

function getSelectedOptionId(item: WorkScopeAPIResource, options: WorkScopeOption[]) {
  if (item.selected_option_id) {
    return item.selected_option_id
  }
  if (item.selected_option_index) {
    if (options.length < item.selected_option_index) {
      return getDefault(options)
    }
    return options[item.selected_option_index].id
  } 
  return getDefault(options)
}

function getDefault(options: WorkScopeOption[]) {
  if (options.length > 0) {
    return options[0].id
  }
  return null
}